import React, {useState} from "react";
import {twJoin} from "tailwind-merge";
import {defaultBorderColor} from "peggirkit";
import {Category, Menu} from "@/data/entities/menu";
import CategoryHeading from "@widgets/menuEditor/menu/categories/category/heading/CategoryHeading";
import ProductsInCategoryTable from "@widgets/menuEditor/menu/categories/category/table/ProductsInCategoryTable";
import EditProductModal, {EditProductModalConfig} from "@widgets/menuEditor/menu/product/EditProductModal";
import CategoryPlanningModal from "@widgets/menuEditor/menu/categories/category/planning/CategoryPlanningModal";

type Props = {
    menu: Menu,
    category: Category,
    isFetching: boolean,
};

const CategoryOverview = ({menu, category, isFetching}: Props) => {
    const [showPlanning, setShowPlanning] = useState(false);
    const [editModal, setEditModal] = useState<EditProductModalConfig>({
        show: false,
        product: null,
    });

    return (
        <li
            data-category-id={category.id}
            className={twJoin("flex flex-col gap-6 w-full border-b", defaultBorderColor)}
        >
            <CategoryHeading
                isFetching={isFetching}
                category={category}
                setEditModal={setEditModal}
                onOpenPlanning={() => setShowPlanning(true)}
            />

            <ProductsInCategoryTable
                menu={menu}
                isFetching={isFetching}
                category={category}
                setEditModal={setEditModal}
            />

            <EditProductModal
                config={editModal}
                setConfig={setEditModal}
                menu={menu}
                category={category}
            />

            <CategoryPlanningModal
                show={showPlanning}
                setShow={setShowPlanning}
                category={category}
            />
        </li>
    );
};

export default CategoryOverview;